import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

import { Box, TablePagination } from '@mui/material'
import DriverKeyModal from '../../../../containers/settings/Modals/DriverKeyModal'
import UnassignModal from '../../../../containers/settings/Modals/UnassignModal'
import KeyModal from '../../../../containers/settings/Modals/keyModal'
import SalesChannelModal from '../../../../containers/settings/Modals/SalesChannelModal'
import HeadOnglet from '../HeadOnglet'
import ModalError from '../../../../components/ModalError'
import ParticipantModal from '../../../../containers/settings/Modals/PartcipantModal'

import FormationModal from '../../../../containers/settings/Modals/FormationModal'
import FormationArchivageModal from '../../../../containers/settings/Modals/FormationArchivageModal'
import FilesModal from '../../../../containers/settings/Modals/FilesModal'
import DriverModal from '../../../../containers/settings/Modals/DriverModal'
import VehiculeModal from '../../../../containers/settings/Modals/VehiculeModal'
import DeleteVehicule from '../../../../containers/settings/Modals/DeleteVehicule'
import TourneeModal from '../../../../containers/settings/Modals/TourneeModal'
import { etatColor } from '../Card/data'
import SessionModal from '../../../../containers/settings/Modals/SessionModal'
import DeleteSession from '../../../../containers/settings/Modals/DeleteSession'
import CancelSession from '../../../../containers/settings/Modals/CancelSession'
import { useLocation } from 'react-router-dom'
import CardMode from '../Card'
import TableContainer from '../Table/ConfigurationTable'
import CompteTiersModal from '../../../../containers/settings/Modals/CompteTiers'

const BodyContainer = ({
  //EtatdisplayMode
  isDisplayMode,
  objectModeDisplay,
  //CardMode
  titleButton,
  iconButtonCreate,
  //TableMode
  actionButton,
  tableHead,
  //Commonfields
  globalID,
  searchPlaceholder,
  title,
  fetchData,
  loadingData,
  dataList,
  countData,
  errorMessage,
  removeError,
  removeErrorConfig,
  isErrorFetch,
  pageLimitChanged,
  pageChanged,
  searchData,
  onCloseReset,
  fetchDataById,
  isErrorFetchById,
  success,
  isSuccessRefresh,
  resetSuccessAction,
  fetchFiles,
  isErrorFetchFileById,

  isSession,
  isKey,
  isDriverKey,
  isChannel,
  isParticipant,
  isFormation,
  isDriver,
  isVehicle,
  isTournee,
  isUser,
  isCompteTiers,
}) => {
  const location = useLocation()

  const getModeDisplay = () => {
    return objectModeDisplay ? objectModeDisplay[location.pathname] : false
  }

  const [open, setOpen] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [openDissociation, setOpenDissociation] = useState(false)
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(25)
  const [row, setRow] = useState({})
  const [openErrorDialog, setOpenErrorDialog] = useState(false)
  const [openDialogPhoto, setOpenDialogPhoto] = useState(false)
  const [openArchiveFormation, setOpenArchiveFormation] = useState(false)
  const [openAnnulation, setOpenAnnulation] = useState(false)
  const [openDelete, setOpenDelete] = useState(false)

  const handleChangePage = (event, newPage) => {
    setPage(newPage)
    pageChanged(newPage * rowsPerPage)
  }

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    pageLimitChanged(parseInt(event.target.value, 10))
    setPage(0)
  }

  const handleClose = () => {
    setOpen(false)
    setIsEdit(false)
  }
  const handleCloseDissociation = () => {
    setOpenDissociation(false)
  }

  useEffect(() => {
    window.addEventListener('beforeunload', onCloseReset)

    return () => {
      onCloseReset()
      window.removeEventListener('beforeunload', onCloseReset)
    }
  }, [])

  useEffect(() => {
    if (errorMessage) {
      setOpenErrorDialog(true)
    }
  }, [errorMessage])

  useEffect(() => {
    fetchData()
  }, [])

  useEffect(() => {
    if (success && isSuccessRefresh) {
      setPage(0)
      setRowsPerPage(25)
      fetchData()
    }
    if (success || isSuccessRefresh) {
      resetSuccessAction()
    }
  }, [success, isSuccessRefresh])

  const setPayloadCancelSession = () => {
    let formData = new FormData()

    formData.append(
      'sessionDto',
      JSON.stringify({ id: row.id, state: etatColor[0].etat })
    )
    return { formData, id: row.id }
  }
  return (
    <>
      <Box
        sx={{
          width: '100%',
          ...(!getModeDisplay() && {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'flex-start',
            '@media (max-width:1200px)': {
              marginTop: 0,
            },
            paddingRight: '24px',
          }),
        }}
      >
        <HeadOnglet
          title={title}
          globalID={globalID}
          onSearch={searchData}
          searchPlaceholder={searchPlaceholder}
          isDisplayMode={isDisplayMode}
          isCardMode={getModeDisplay()}
          isButtonCreate={getModeDisplay()}
          iconButtonCreate={iconButtonCreate}
          actionButtonCreate={() => {
            setOpen(true)
          }}
          titleButtonCreate={`Ajouter ${titleButton}`}
        />
        {getModeDisplay() ? (
          <CardMode
            loadingData={loadingData}
            dataList={dataList}
            titleOnglet={titleButton}
            setRowElement={setRow}
            setOpenCancel={setOpenAnnulation}
            fetchDataById={fetchDataById}
            setOpenModal={setOpen}
            setIsEditAction={setIsEdit}
            setOpenModelDelete={setOpenDelete}
            isSession={isSession}
          />
        ) : (
          <TableContainer
            globalID={globalID}
            tableHead={tableHead}
            titleOnglet={titleButton}
            loadingData={loadingData}
            tableRows={dataList}
            actionButton={actionButton}
            fetchFiles={fetchFiles}
            fetchDataById={fetchDataById}
            setOpen={setOpen}
            setOpenDialogPhoto={setOpenDialogPhoto}
            setOpenArchiveFormation={setOpenArchiveFormation}
            setRow={setRow}
            setIsEdit={setIsEdit}
            setOpenAnnulation={setOpenAnnulation}
            setOpenDissociation={setOpenDissociation}
            setOpenDelete={setOpenDelete}
            isParticipant={isParticipant}
            isFormation={isFormation}
            isDriver={isDriver}
            isVehicle={isVehicle}
            isTournee={isTournee}
            isUser={isUser}
            isSession={isSession}
            isKey={isKey}
            isDriverKey={isDriverKey}
            isChannel={isChannel}
            isCompteTiers={isCompteTiers}
          />
        )}
      </Box>
      <TablePagination
        component="div"
        rowsPerPageOptions={[25, 50, 100, 200]}
        sx={{
          width: '100%',
          display: 'flex',
          justifyContent: getModeDisplay() ? 'center' : 'end',
          paddingRight: !getModeDisplay() && '24px !important',
        }}
        count={countData}
        rowsPerPage={rowsPerPage}
        page={page}
        labelRowsPerPage="lignes par page"
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
      {errorMessage && (
        <ModalError
          open={openErrorDialog}
          handleCloseDialog={() => {
            setOpenErrorDialog(false)
            removeError()
            removeErrorConfig()
            //Fermer le dialog s’il est ouvert
            setOpen(false)
            setOpenDissociation(false)
            setOpenErrorDialog(false)
            setOpenDialogPhoto(false)
            setOpenArchiveFormation(false)
            setOpenAnnulation(false)
            setOpenDelete(false)
          }}
          handleActionButton={() => {
            setOpenErrorDialog(false)
            removeError()
            removeErrorConfig()
            isErrorFetch && fetchData()
            isErrorFetchById && fetchDataById(row.id)
            isErrorFetchFileById && fetchFiles(row.id)
          }}
          message={errorMessage}
          isModalActionActualiser={isErrorFetch || isErrorFetchById}
        />
      )}
      {isKey && open && (
        <KeyModal
          isEdit={isEdit}
          handleClose={handleClose}
          modalTitle={isEdit ? ' Modifier une clé ' : 'Ajouter une clé'}
          open={open}
          row={row}
        />
      )}
      {isDriverKey && open && (
        <DriverKeyModal
          isEdit={isEdit}
          handleClose={handleClose}
          modalTitle={'Affecter une clé à un chauffeur'}
          open={open}
        />
      )}
      {isChannel && open && (
        <SalesChannelModal
          isEdit={isEdit}
          handleClose={handleClose}
          modalTitle={'Affecter une clé à un canal'}
          open={open}
        />
      )}
      {isUser && open && (
        <ParticipantModal
          isEdit={isEdit}
          handleClose={handleClose}
          modalTitle={isEdit ? 'Modifier Utilisateur' : 'Ajouter Utilisateur'}
          open={open}
          row={row}
        />
      )}
      {isDriver && open && (
        <DriverModal
          isEdit={isEdit}
          handleClose={handleClose}
          modalTitle={isEdit ? ' Modifier Chauffeur ' : 'Ajouter Chauffeur'}
          open={open}
          row={row}
        />
      )}
      {isVehicle && open && (
        <VehiculeModal
          isEdit={isEdit}
          handleClose={handleClose}
          modalTitle={isEdit ? ' Modifier Véhicule ' : 'Ajouter Véhicule'}
          open={open}
          row={row}
        />
      )}
      {isFormation && open && (
        <FormationModal
          isEdit={isEdit}
          handleClose={handleClose}
          modalTitle={isEdit ? ' Modifier Formation ' : 'Ajouter Formation'}
          open={open}
          formationId={row.id}
        />
      )}
      {isTournee && open && (
        <TourneeModal
          isEdit={isEdit}
          handleClose={handleClose}
          modalTitle={isEdit ? ' Modifier Ressource ' : 'Ajouter nouvelle ressource'}
          open={open}
          row={row}
        />
      )}
      {isSession && open && (
        <SessionModal
          isEdit={isEdit}
          sessionId={row.id}
          handleClose={handleClose}
          modalTitle={isEdit ? ' Modifier Sessions ' : 'Ajouter Session'}
          open={open}
          session={row}
        />
      )}
      {openDissociation && (
        <UnassignModal
          isDriver={isDriverKey}
          handleClose={handleCloseDissociation}
          textContent={'Vous voulez vraiment dissocier cette clé.'}
          modalTitle={
            isDriverKey ? 'Dissociation Clé-chauffeur' : 'Dissociation Clé-canal'
          }
          open={openDissociation}
          row={row}
          actionData={
            isDriverKey
              ? { keyId: row.keys[0].id, driverId: row.id }
              : { keyId: row.keys[0].id, salesChanelCode: row.code }
          }
        />
      )}
      {openArchiveFormation && (
        <FormationArchivageModal
          handleClose={() => setOpenArchiveFormation(false)}
          textContent={'Vous voulez vraiment archiver ce formation.'}
          modalTitle={'Archivage Formation'}
          open={openArchiveFormation}
          row={row}
          actionData={{ ids: [row.id] }}
        />
      )}
      {openDialogPhoto && (
        <FilesModal
          globalID={globalID}
          open={openDialogPhoto}
          onClose={() => {
            setOpenDialogPhoto(false)
          }}
        />
      )}
      {isSession && openAnnulation && (
        <CancelSession
          handleClose={() => setOpenAnnulation(false)}
          textContent={'Vous voulez vraiment annuler cette session.'}
          modalTitle={'Annuler Session'}
          open={openAnnulation}
          actionData={setPayloadCancelSession()}
        />
      )}
      {isVehicle && openDelete && (
        <DeleteVehicule
          handleClose={() => setOpenDelete(false)}
          textContent={'Vous voulez vraiment supprimer ce véhicule.'}
          modalTitle={'Suppression véhicule'}
          open={openDelete}
          actionData={row.id}
        />
      )}
      {isSession && openDelete && (
        <DeleteSession
          handleClose={() => setOpenDelete(false)}
          textContent={'Vous voulez vraiment supprimer cette session.'}
          modalTitle={'Supprimer Session'}
          open={openDelete}
          row={row}
          actionData={{ ids: [row.id] }}
        />
      )}
      {isCompteTiers && open && (
        <CompteTiersModal
          isEdit={isEdit}
          handleClose={handleClose}
          modalTitle={isEdit ? 'Modifier Utilisateur' : 'Ajouter Utilisateur'}
          open={open}
          row={row}
        />
      )}
    </>
  )
}

BodyContainer.propTypes = {
  //EtatdisplayMode
  isDisplayMode: PropTypes.bool,
  objectModeDisplay: PropTypes.object,
  //CardMode
  titleButton: PropTypes.string,
  iconButtonCreate: PropTypes.any,
  //TableMode
  actionButton: PropTypes.bool,
  tableHead: PropTypes.array,
  //Commonfields
  globalID: PropTypes.string,
  searchPlaceholder: PropTypes.string,
  title: PropTypes.string,
  fetchData: PropTypes.func,
  loadingData: PropTypes.bool,
  dataList: PropTypes.array,
  countData: PropTypes.number,
  errorMessage: PropTypes.string,
  removeError: PropTypes.func,
  removeErrorConfig: PropTypes.func,
  isErrorFetch: PropTypes.bool,
  pageLimitChanged: PropTypes.func,
  pageChanged: PropTypes.func,
  searchData: PropTypes.func,
  onCloseReset: PropTypes.func,
  fetchDataById: PropTypes.func,
  isErrorFetchById: PropTypes.bool,
  resetSuccessAction: PropTypes.func,
  fetchFiles: PropTypes.func,
  isErrorFetchFileById: PropTypes.bool,

  isSession: PropTypes.bool,
  isKey: PropTypes.bool,
  isDriverKey: PropTypes.bool,
  isChannel: PropTypes.bool,
  isParticipant: PropTypes.bool,
  isFormation: PropTypes.bool,
  isDriver: PropTypes.bool,
  isVehicle: PropTypes.bool,
  isTournee: PropTypes.bool,
  isUser: PropTypes.bool,
  success: PropTypes.bool,
  isSuccessRefresh: PropTypes.bool,
  isCompteTiers: PropTypes.bool,
}

export default BodyContainer
